var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBox = function SvgBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.2rem",
    height: "1.35rem",
    viewBox: "0 0 23.156 27"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.218 6.052 12.57.274a1.928 1.928 0 0 0-1.982 0L.938 6.052A1.93 1.93 0 0 0 0 7.708V19.5c0 .69.368 1.326.965 1.67l9.649 5.572a1.928 1.928 0 0 0 1.929 0l9.649-5.571a1.93 1.93 0 0 0 .964-1.671V7.708a1.93 1.93 0 0 0-.938-1.656zM11.627 1.081l9.77 6.032-9.78 6.042-9.765-6.04 9.775-6.034zM1.302 8.471l9.55 5.57v11.201l-9.55-5.36V8.473zM12.65 25.254v-11.21l9.549-5.575v11.415l-9.55 5.37z"
  })));
};
export default SvgBox;